import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnginAtelierService } from 'src/app/core/_services/engin.atelier.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dialog-download-calcul-ceu-engins',
  templateUrl: './dialog-download-calcul-ceu-engins.component.html',
  styleUrls: ['./dialog-download-calcul-ceu-engins.component.scss']
})
export class DialogDownloadCalculCeuEnginsComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogDownloadCalculCeuEnginsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: EnginAtelierService
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  downloadExcelForCalculCeuEngins(): void {
    this.service.getExcelForCalculCeuEngins('FeuilleCalculCEE.xlsx').subscribe((data) => {
      if (data) {
        const fileName = 'calcul.xlsx';
        this.downloadFile(data, fileName);
      }
      this.dialogRef.close();
    });
  }

  downloadFile(data: Blob, fileName: string) {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const blob = new Blob([data], { type: contentType });
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}
